"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    id: "mf-login",
    class: "o-page-wrap mx-auto min-h-[70rem] w-full max-w-[490px]"
};
const _hoisted_2 = { class: "ocm-headline2 mb-6 pt-8" };
const _hoisted_3 = {
    id: "country_desc_1",
    class: "mb-5 mt-6"
};
const _hoisted_4 = {
    key: 0,
    class: "mt-4 flex text-gray-70",
    "data-test-address-country-info": ""
};
const _hoisted_5 = { id: "country_desc_2" };
const _hoisted_6 = ["href"];
const _hoisted_7 = ["href"];
const _hoisted_8 = ["href"];
const _hoisted_9 = ["href"];
const SharedButton_vue_1 = __importDefault(require("@SharedVueComponents/SharedButton.vue"));
const SharedDropdown_vue_1 = __importDefault(require("@SharedVueComponents/SharedDropdown.vue"));
const SharedForm_vue_1 = __importDefault(require("@SharedVueComponents/SharedForm/SharedForm.vue"));
const SharedRadio_vue_1 = __importDefault(require("@SharedVueComponents/SharedRadio/SharedRadio.vue"));
const SharedRadioGroup_vue_1 = __importDefault(require("@SharedVueComponents/SharedRadio/SharedRadioGroup.vue"));
const SvgIcon_vue_1 = __importDefault(require("@SharedVueComponents/SvgIcon/SvgIcon.vue"));
const use_footer_1 = require("@SharedVueComposables/use-footer");
const ocm_object_1 = require("@ocm/services/ocm-object");
const axios_1 = require("@ocm/axios");
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const dataLayerLogin_1 = require("@/services/dataLayerLogin");
const ocm_mercurius_messenger_1 = __importDefault(require("ocm_mercurius_messenger"));
const services_constants_1 = require("@ocm/services/services.constants");
const departmentCookie_1 = require("@ocm/services/departmentCookie");
const flagBaseUrl = "/_ui/responsive/common/images/flags/";
exports.default = (0, vue_1.defineComponent)({
    __name: 'RegisterLastStepPage',
    setup(__props) {
        var _a, _b;
        const { t } = (0, vue_i18n_1.useI18n)();
        const confirmationPage = (_b = (_a = window.ocm) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.confirmationPage;
        const salutation = (0, vue_3.ref)(null);
        const backendErrorMessage = (0, vue_3.ref)();
        const isLoading = (0, vue_3.ref)(false);
        const isDeliveryCountry = (0, vue_3.computed)(() => DEFAULT_COUNTRY.includes(country.value || ""));
        const hasDepartmentCookieOnload = !!(0, departmentCookie_1.getDepartmentCookie)();
        const selectableCountryItems = transformSelectableCountries(confirmationPage === null || confirmationPage === void 0 ? void 0 : confirmationPage.selectableCountries);
        const country = (0, vue_3.ref)(getPreselectedCountry());
        const flagURLs = getFlagURLs(confirmationPage === null || confirmationPage === void 0 ? void 0 : confirmationPage.selectableCountries);
        const DEFAULT_COUNTRY = ["DE", "AT", "CH"];
        (0, use_footer_1.keepFooterOnBottom)();
        function getPreselectedCountry() {
            if (!(confirmationPage === null || confirmationPage === void 0 ? void 0 : confirmationPage.selectableCountries))
                return;
            const preselectedCountry = confirmationPage === null || confirmationPage === void 0 ? void 0 : confirmationPage.preferredCountryIsoCode;
            if (!preselectedCountry || !selectableCountryItems[preselectedCountry]) {
                return confirmationPage.selectableCountries[0].isocode;
            }
            return preselectedCountry;
        }
        function submitForm(event) {
            return __awaiter(this, void 0, void 0, function* () {
                isLoading.value = true;
                try {
                    const form = getFormFromEvent(event);
                    if (!form)
                        return;
                    if (!hasDepartmentCookieOnload)
                        sendChangeDepartment(salutation.value || "mr");
                    const response = yield postFormData(form);
                    handleSubmitResponse(response.data);
                }
                catch (err) {
                    handleSubmitError(err);
                }
            });
        }
        function getFormFromEvent(event) {
            return event.target.closest("form");
        }
        function postFormData(form) {
            return __awaiter(this, void 0, void 0, function* () {
                const requestUrl = (confirmationPage === null || confirmationPage === void 0 ? void 0 : confirmationPage.formAction) || "";
                return axios_1.$axios.post(requestUrl, getEncodedFormData(form), {
                    params: getUrlQueryParams(),
                });
            });
        }
        function getEncodedFormData(form) {
            const formData = new FormData(form);
            const formEncoded = new URLSearchParams();
            formData.forEach((value, key) => {
                if (typeof value === "string") {
                    formEncoded.append(key, value);
                }
            });
            return formEncoded.toString();
        }
        function getUrlQueryParams() {
            return Object.fromEntries(new URLSearchParams(window.location.search));
        }
        function handleSubmitResponse(data) {
            if (data.httpStatus === 200) {
                window.location = data.redirectUrl;
            }
            else {
                handleError();
            }
        }
        function handleSubmitError(error) {
            var _a, _b;
            const errorMessages = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.globalErrorMessages;
            handleError(errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages[0]);
        }
        function handleError(newErrorMessage) {
            backendErrorMessage.value = newErrorMessage || t("lastStep.default_backend_error_message");
            trackBackendError(backendErrorMessage.value);
            isLoading.value = false;
        }
        function transformSelectableCountries(countries) {
            if (!countries)
                return {};
            return countries.reduce((acc, country) => {
                acc[country.isocode] = country.name;
                return acc;
            }, {});
        }
        function getFlagURLs(countries) {
            if (!countries)
                return [];
            return countries.map((country) => flagBaseUrl + country.flag, {});
        }
        (0, vue_3.watch)(country, () => {
            trackCountryChange();
        });
        const agbUrl = ocm_object_1.language === "de" ? "/de/metzingen/agb/" : "/en/metzingen/terms/";
        const dataProtectionUrl = ocm_object_1.language === "de" ? "/de/metzingen/datenschutz/" : "/en/metzingen/data-protection/";
        const newAgbUrl = ocm_object_1.language === "de" ? "/de/metzingen/outletcity-agb/" : "/en/metzingen/outletcity-terms/";
        const clubTermsUrl = ocm_object_1.language === "de" ? "/de/metzingen/club-bedingungen/" : "/en/metzingen/club-terms/";
        function handleSalutationChange(errorMessage) {
            if (errorMessage)
                trackSalutationError();
        }
        function trackSubmit() {
            (0, dataLayerLogin_1.pushEvent)("RegisterButton");
        }
        function trackCountryChange() {
            (0, dataLayerLogin_1.pushEvent)("change_country");
        }
        function trackSalutationError() {
            (0, dataLayerLogin_1.pushEvent)("submit_salutation_error");
        }
        function trackBackendError(errorMessage) {
            (0, dataLayerLogin_1.pushEvent)("submit_backend_error", errorMessage);
        }
        const SALUTATION_TO_DEPARTMENT_MAP = {
            mr: "men",
            mrs: "women",
        };
        function sendChangeDepartment(salutation) {
            const department = SALUTATION_TO_DEPARTMENT_MAP[salutation] || "";
            ocm_mercurius_messenger_1.default.publish(services_constants_1.messengerPublicationTypes.DEPARTMENT_CHANGE, department);
        }
        return (_ctx, _cache) => {
            const _component_i18n_t = (0, vue_2.resolveComponent)("i18n-t");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("h1", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.headline")), 1),
                (0, vue_2.createVNode)(SharedForm_vue_1.default, {
                    class: "ocm-body1 mb-15 mt-4",
                    "no-submit-button-gap": "",
                    novalidate: "novalidate",
                    "error-message": backendErrorMessage.value || (0, vue_2.unref)(t)('lastStep.required_error_message'),
                    "show-error": !!backendErrorMessage.value ? true : undefined,
                    onChange: _cache[3] || (_cache[3] = ($event) => (backendErrorMessage.value = undefined)),
                    onSubmit: submitForm
                }, {
                    submitButton: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(SharedButton_vue_1.default, {
                            type: "submit",
                            class: "w-full",
                            "is-loading": isLoading.value,
                            onClick: trackSubmit
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.submit")), 1)
                            ]),
                            _: 1
                        }, 8, ["is-loading"])
                    ]),
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createVNode)(SharedRadioGroup_vue_1.default, {
                            modelValue: salutation.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((salutation).value = $event)),
                            name: "gender",
                            "display-name": (0, vue_2.unref)(t)('lastStep.salutation_display_name'),
                            label: `${(0, vue_2.unref)(t)('lastStep.salutation_label')} ${(0, vue_2.unref)(t)('lastStep.required_label')}`,
                            "required-error-message": (0, vue_2.unref)(t)('lastStep.salutation_error_message'),
                            "inner-class": "mt-4 flex gap-4",
                            required: "",
                            onChangeErrorMsg: _cache[1] || (_cache[1] = (_, data) => handleSalutationChange(data.errorMessage))
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(SharedRadio_vue_1.default, { "radio-value": "mrs" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.salutation_ms")), 1)
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(SharedRadio_vue_1.default, { "radio-value": "mr" }, {
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.salutation_mr")), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }, 8, ["modelValue", "display-name", "label", "required-error-message"]),
                        (0, vue_2.createElementVNode)("p", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.which_country")), 1),
                        (0, vue_2.createVNode)(SharedDropdown_vue_1.default, {
                            modelValue: country.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((country).value = $event)),
                            name: "originCountryCode",
                            "display-name": (0, vue_2.unref)(t)('lastStep.country_display_name'),
                            placeholder: `${(0, vue_2.unref)(t)('lastStep.country_placeholder')}`,
                            label: `${(0, vue_2.unref)(t)('lastStep.country_display_name')} ${(0, vue_2.unref)(t)('lastStep.required_label')}`,
                            options: (0, vue_2.unref)(selectableCountryItems),
                            "image-urls": (0, vue_2.unref)(flagURLs),
                            required: "",
                            "aria-describedby": 'country_desc_1' + (!isDeliveryCountry.value ? ' country_desc_2' : '')
                        }, null, 8, ["modelValue", "display-name", "placeholder", "label", "options", "image-urls", "aria-describedby"]),
                        (!isDeliveryCountry.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, [
                                (0, vue_2.createVNode)(SvgIcon_vue_1.default, {
                                    class: "mr-2 size-5 flex-none p-px",
                                    "icon-name": "info"
                                }),
                                (0, vue_2.createElementVNode)("p", _hoisted_5, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.shipping_only_in_germany")), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (0, vue_2.createVNode)(_component_i18n_t, {
                            keypath: "lastStep.legal",
                            tag: "p",
                            class: "ocm-subtext1 my-6"
                        }, {
                            terms: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("a", {
                                    href: (0, vue_2.unref)(agbUrl),
                                    class: "underline"
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.terms")), 9, _hoisted_6)
                            ]),
                            dataProtection: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("a", {
                                    href: (0, vue_2.unref)(dataProtectionUrl),
                                    class: "underline"
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.privacy_policy")), 9, _hoisted_7)
                            ]),
                            newTerms: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("a", {
                                    href: (0, vue_2.unref)(newAgbUrl),
                                    class: "underline"
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.terms")), 9, _hoisted_8)
                            ]),
                            clubTerms: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("a", {
                                    href: (0, vue_2.unref)(clubTermsUrl),
                                    class: "underline"
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)("lastStep.club_terms")), 9, _hoisted_9)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["error-message", "show-error"])
            ]));
        };
    }
});
